<router-outlet></router-outlet>
<ngx-guided-tour [nextText]="'Siguiente'"
                [backText]="'Anterior'"
                [skipText]="'Omitir'"
                [doneText]="'Hecho'">
</ngx-guided-tour>